import React, { Fragment, useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { goBack, push } from "connected-react-router";
import { actions as loginActions } from "reducers/login";
import { actions as onboardingActions } from "reducers/onboarding";
import gaEventTracker, { events } from "util/gaEventTracker";
import Notification from "pages/_components/Notification";
import { Col, Row } from "react-bootstrap";
import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { bool } from "prop-types";
import Logo from "pages/login/_components/Logo";
import * as i18n from "util/i18n";
import LogoTitle from "pages/login/_components/LogoTitle";
import Head from "pages/_components/Head";
import ErrorPopup from "../_components/ErrorPopup";

const LoginRegister = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const [initialized, setInitialized] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!initialized && !!dispatch) {
            dispatch(loginActions.initLoginFlow());
            setInitialized(true);
            window.common.hideSplashScreen();
            setError("");
            // setTimeout(() => { setLoading(false) }, 3000);
        }
    }, [initialized, setInitialized, dispatch, setError]);

    const onStartEnrollment = () => {
        if (!window.cordova) {
            dispatch(push("/onboarding/stepStartOnMobile"));
        } else {
            gaEventTracker.triggerEvent(events.registry0);
            dispatch(onboardingActions.setOnboardingWithInvitation(false));
            dispatch(push("/onboarding/stepStart"));
        }
    };

    const onStartEnrollmentWithInvitation = () => {
        if (!window.cordova) {
            dispatch(push("/onboarding/stepStartOnMobile"));
        } else {
            dispatch(push("/onboarding/stepInvitationCode"));
        }
    };

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const onStartWithEnrolledUser = () => {
        if (!window.cordova) {
            dispatch(push("/onboarding/stepStartOnMobile"));
        } else {
            dispatch(onboardingActions.setOnboardingWithEnrolledUser(true));
            dispatch(push("/onboarding/stepStartEnrolledUser"));
        }
    };

    const getDesktopView = () => (
        <div>
            <Head
                title=""
                styleOther={{ backgroundColor: "transparent", boxShadow: "none" }}
                onBack={onHeaderBack}
                hideNavbarInMobile
            />
            <section className="container--layout">
                <main className="app-default-content" role="main">
                    <Container className="items-center container--layout">
                        <Col className="col-12">
                            <div className="text-center">
                                <Logo className="svg-image logo" />
                            </div>
                            <h1 className="text-center">
                                <I18n defaultValue="Elegí una de las opciones:" />
                            </h1>
                            <Button
                                className="mt-8"
                                onClick={onStartEnrollment}
                                style={{ marginTop: "50px" }}
                                bsStyle="primary"
                                defaultLabelText="Registrarme"
                                block
                            />
                            <Button
                                className="btn-outline"
                                onClick={onStartEnrollmentWithInvitation}
                                label=""
                                defaultLabelText={i18n.get("", "Tengo una invitación")}
                                block
                            />
                            <Button
                                className="btn-link"
                                onClick={onStartWithEnrolledUser}
                                label=""
                                defaultLabelText={i18n.get("onboarding.enrolled.user", "Registrar otra empresa")}
                                block
                            />
                        </Col>
                        <Row style={{ marginTop: "50px", textAlign: "center" }}>
                            <Col className="col-12">
                                <a href="https://www.bibank.com.ar/" target="_blank" rel="noreferrer">
                                    Mas información
                                </a>
                            </Col>
                        </Row>
                    </Container>
                </main>
            </section>
        </div>
    );

    const getMobileView = () => (
        <Fragment>
            <Head
                id="onboarding.business.title"
                onBack={onHeaderBack}
                hideNavbarInMobile
                styleOther={{ backgroundColor: "transparent", boxShadow: "none" }}
            />
            <LogoTitle />
            <Container className="container--layout login-register">
                <Col className="col-12">
                    <h1 className="text-center">
                        <I18n defaultValue="Elegí una de las opciones:" />
                    </h1>
                    <div className="login-register__buttons">
                        <Button onClick={onStartEnrollment} bsStyle="primary" defaultLabelText="Registrarme" block />
                        <Button
                            className="btn-outline"
                            onClick={onStartEnrollmentWithInvitation}
                            label=""
                            defaultLabelText={i18n.get("", "Tengo una invitación")}
                            block
                        />
                        <Button
                            className="btn-link"
                            onClick={onStartWithEnrolledUser}
                            label=""
                            defaultLabelText={i18n.get("onboarding.enrolled.user", "Registrar otra empresa")}
                            block
                        />
                    </div>
                </Col>
                <div className="register-links">
                    <div className="help-links">
                        <a href="#" onClick="window.open('https://www.bibank.com.ar/')">
                            <I18n componentProps={{ className: "small" }} id="accounts.information" />
                        </a>
                        {" | "}
                        <Link to="/tokenVirtual" style={{ textAlign: "right" }} className="small">
                            <I18n id="onboarding.token" />
                        </Link>
                    </div>
                </div>
            </Container>
        </Fragment>
    );

    return (
        <Fragment>
            <Notification scopeToShow="login" />
            {isDesktop ? getDesktopView() : getMobileView()}
            <ErrorPopup error={error} />
        </Fragment>
    );
};

LoginRegister.propTypes = {
    isDesktop: bool.isRequired,
};

export default withRouter(LoginRegister);
